import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import api from '@/lib/api'

const store = new Vuex.Store({
  state: {
    isAdmin: false,
    isLoading: false,
    user: {},
    reports: [],
    reportTemplates: [],
    allReports: [] // List of reports for *all* users. Only available to admin.
  },

  mutations: {
    setIsAdmin (state, isAdmin) {
      state.isAdmin = isAdmin
    },
    setAllReports (state, reports) {
      state.allReports = reports
    },
    setUser (state, user) {
      state.user = user
    },
    setReports (state, reports) {
      reports = reports.map((r) => {
        if (typeof (r.tod) === 'string') {
          r.tod = r.tod.split(',').map((i) => { return parseInt(i, 10) })
        }
        if (typeof (r.dow) === 'string') {
          r.dow = r.dow.split(',').map((i) => { return parseInt(i, 10) })
        }
        return r
      })
      state.reports = reports
    },
    setReportTemplates (state, reportTemplates) {
      reportTemplates = reportTemplates.map((t) => {
        if (typeof (t.tod) === 'string') {
          t.tod = t.tod.split(',').map((i) => { return parseInt(i, 10) })
        }
        return t
      })
      state.reportTemplates = reportTemplates
    },
    addNewTemplate (state) {
      state.reportTemplates.push({
        id: null,
        data: {
          images: []
        }
      })
    },
    addNewReport (state) {
      state.reports.push({})
    },
    setIsLoading (state, value) {
      state.isLoading = value
    }
  },

  actions: {
    async getAppState ({commit}) {
      commit('setIsLoading', true)
      const config = await api.get('config')
      commit('setIsAdmin', config.isAdmin)
      commit('setUser', config.user)
      commit('setReports', config.reports)
      const templates = config.reportTemplates.filter((t) => {
        return t.public
      }).map((t) => {
        if (!t.tod) { t.tod = [] }
        if (!t.dow) { t.dow = [] }
        return t
      })
      commit('setReportTemplates', templates)
      commit('setIsLoading', false)
    },
    async getAllReports ({commit}) {
      const reports = await api.get('all-reports')
      commit('setAllReports', reports)
    },
    async setAllReports ({dispatch}, reports) {
      await api.post('all-reports', { reports })
      dispatch('getAppState')
      dispatch('getAllReports')
    },
    async getReportTemplates ({commit}) {
      const templates = await api.get('report-templates')
      commit('setReportTemplates', templates)
    },
    async addReportTemplate ({commit, dispatch}, template) {
      await api.post(`report-templates`, {
        name: template.name,
        name_short: template.name_short,
        public: true,
        data: template.data,
        intro: template.intro,
        close: template.close,
        tod: template.tod,
        dow: template.dow
      })
      dispatch('getAppState')
    },
    async deleteReportTemplate ({commit, dispatch}, template) {
      await api.post(`report-templates/${template.id}/delete`)
      dispatch('getAppState')
    },
    async updateReportTemplate ({commit, dispatch}, template) {
      await api.post(`report-templates/${template.id}/update`, {
        name: template.name,
        name_short: template.name_short,
        public: true,
        data: template.data,
        intro: template.intro,
        close: template.close,
        tod: template.tod,
        dow: template.dow
      })
      dispatch('getAppState')
    },
    async addReport ({dispatch}, report) {
      await api.post(`mine`, report)
      dispatch('getAppState')
    },
    async updateReport ({dispatch}, report) {
      await api.post(`mine/${report.id}/update`, report)
      dispatch('getAppState')
    },
    async deleteReport ({dispatch}, report) {
      await api.post(`mine/${report.id}/delete`, report)
      dispatch('getAppState')
    },
    async sendReportNow ({dispatch, commit}, report) {
      commit('setIsLoading', true)
      await api.post(`mine/${report.id}/send`, report)
      await dispatch('getAppState')
      commit('setIsLoading', false)
    }
  },

  getters: {
    reportTemplateIDs (state) {
      return state.reportTemplates.map((t) => { return t.id })
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/lib/store.js